import React from "react";
import { Box, Typography, Button } from "@mui/material";
import Image from "next/image";
import { useRouter } from "next/navigation";

type Props = {
  children: any;
};

const Container = ({ children }: Props) => {
  const router = useRouter();

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100dvh",
        overflow: "hidden",
      }}
    >
      {/* Fullscreen Background Image */}
      <Image
        src="/assets/images/landingImage.jpg"
        alt="Background"
        layout="fill"
        objectFit="cover"
        quality={100}
      />

      {/* Overlay with Bottom Modal */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(10, 10, 10, 0.4)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
        }}
      >
        {/* Back Button */}
        <Button
          onClick={() => router.push("/")}
          sx={{
            position: "absolute",
            top: "53px",
            left: "24px",
            width: "42px",
            height: "42px",
            borderRadius: "16px",
            backgroundColor: "#F4F5F0",
            color: "#0A0A0A",
            zIndex: 2,
            padding: "12px",
            minWidth: "auto",
            fontSize: "18px",
            "&:hover": {
              backgroundColor: "#F4F5F0",
            },
          }}
        >
          ←
        </Button>

        <Box
          sx={{
            position: "absolute",
            top: { xs: "env(safe-area-inset-top, 12px)", sm: 24 },
            right: { xs: 8, sm: 16 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            zIndex: 2,
            width: { xs: "40vw", sm: "100%" },
            minWidth: 100,
            maxWidth: 200,
            paddingTop: "env(safe-area-inset-top)",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: { xs: "8vh", sm: 46 },
              minHeight: 120,
              maxHeight: 120,
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Image
              src="/assets/images/MSAWHITELOGO.svg"
              alt="Driver Profile"
              width={80}
              height={80}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </Box>

          <Typography
            sx={{
              marginTop: "-24px",
              color: "#FFFFFF",
              fontFamily: "SF Pro",
              fontWeight: 500,
              fontSize: "10px",
              textAlign: "center",
              wordBreak: "break-word",
            }}
          >
            MYSERVICEAPP.COM
          </Typography>
        </Box>

        {/* Bottom Full-Width Modal */}
        <Box
          sx={{
            width: "100%",
            height: "572px",
            backgroundColor: "#F4F5F0",
            borderTopLeftRadius: "48px",
            borderTopRightRadius: "48px",
            padding: "40px 24px 40px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            opacity: 1,
            margin: "0 auto",
            overflowY: "auto",
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <Box sx={{ textAlign: "center" }}>
              <Typography
                sx={{
                  fontFamily: "SF Pro",
                  fontWeight: 510,
                  fontSize: "32px",
                  color: "#0A0A0A",
                  mb: 1,
                }}
              >
                Sign Up
              </Typography>
              <Typography
                sx={{
                  fontFamily: "SF Pro",
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#727272",
                }}
              >
                Please provide your contact information to continue
              </Typography>
            </Box>
          </Box>

          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Container;
